export enum EnumIntegrationStatus  {
    Connected = "connected",
    Disconnected = "disconnected",
    Pending = "pending"
}

export type IIntegrationApp = {
    id: number;
    name: string;           
    description: string;     
    logoUrl: string;
    connectionStatus: EnumIntegrationStatus;
};

// If your GET /app returns an array:
export type IntegrationsListRes = IIntegrationApp[];

export type AuthorizeResponse =
    | { url: string }
    | { status: "ok" };
